import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import {
  Card,
  Button,
  Col,
} from "react-bootstrap";

import errores from "../../middleware/errordb";

import config from "../../config";
import Mensajes from "../subcomponent/mensajes";
import ModalConfirm from "../subcomponent/modalConfirm";
import TitleModule from "../widgets/module_title";
import BackButton from "../widgets/back_button";

class FormularioMail extends Component {
  constructor(props) {
    super(props);

    const currentCompany = sessionStorage.getItem("company");
    const currentUserType = sessionStorage.getItem("tipo");
    this.state = {
      mail: "",
      host: "",
      pass: "",
      puerto: "",
      usuario: "",
      copia: 0,
      protocolo: 1,
      tipo: currentUserType,
      empresa: currentCompany,
      proceso: "Crear",
      mostrarMensaje: false,
      mensaje: "",
      copiaadicional: "",
      ShowOrderEmail: false,
      copiaPedido1: '',
      copiaPedido2: ''
    };
  }

  componentDidMount() {
    const empresaEdicion = this.state.empresa;
    if (empresaEdicion) {
      const datasend = {
        method: "GET",

        headers: {
          "Content-Type": "application/json",
          empresa: this.state.empresa,
          tipo: this.state.tipo,
        },
      };
      fetch(config.servBackEnd + "/email", datasend)
        .then((response) => response.json())
        .then((data) => {
          if (data.ok) {
            data = data.data[0];
            const valid1 = (data.COPIA_PEDIDOS_1 && data.COPIA_PEDIDOS_1 !== '')
            const valid2 = (data.COPIA_PEDIDOS_2 && data.COPIA_PEDIDOS_2 !== '')
            const ShowOrderEmail = (valid1 || valid2)
            this.setState({
              mail: data.EMAIL,
              host: data.HOST_EMAIL,
              pass: data.PASSWORD_EMAIL,
              puerto: data.PORT_EMAIL,
              protocolo: data.PROTOCOLO,
              usuario: data.USUARIO_EMAIL,
              copia: data.COPIA_CORREO,
              copiaadicional: data.COPIA_ADICIONAL,
              copiaPedido1: data.COPIA_PEDIDOS_1,
              copiaPedido2: data.COPIA_PEDIDOS_2,
              proceso: "Modificar",
              ShowOrderEmail
            });
          } else {
            this.setState({
              mostrarMensaje: true,
              mensaje:
                "Configuracion obligatoria para el correcto funcionamiento",
            });
            //console.log();
          }
        });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState({ show: true });
  };

  sendTest = () => {
    const datasend = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        empresa: this.state.empresa,
      },
    };
    fetch(config.servBackEnd + "/email/test", datasend)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        this.setState({ mostrarMensaje: true, mensaje: data.message });
      });
  };
  enviarInfo = () => {
    this.setState({ show: false });
    const { empresa } = this.state;
    const { mail } = this.state;
    const { host } = this.state;
    const { pass } = this.state;
    const { puerto } = this.state;
    const { protocolo } = this.state;
    const { usuario } = this.state;
    const { copia } = this.state;
    const { copiaadicional } = this.state;
    const { ShowOrderEmail } = this.state;
    let { copiaPedido1 } = this.state;
    let { copiaPedido2 } = this.state;
    let ruta = "";

    if (!ShowOrderEmail) {
      copiaPedido1 = '';
      copiaPedido2 = '';
    }

    const datasend = {
      method: "POST",
      body: JSON.stringify({
        ID_EMPRESA: empresa,
        HOST_EMAIL: host,
        PASSWORD_EMAIL: pass,
        PORT_EMAIL: puerto,
        PROTOCOLO: protocolo,
        EMAIL: mail,
        USUARIO_EMAIL: usuario,
        COPIA_CORREO: copia,
        COPIA_ADICIONAL: copiaadicional,
        COPIA_PEDIDOS_1: copiaPedido1,
        COPIA_PEDIDOS_2: copiaPedido2
      }),
      headers: {
        "Content-Type": "application/json",
        tipo: this.state.tipo,
        empresa: this.state.empresa,
      },
    };

    if (this.state.proceso === "Crear") {
      ruta = config.servBackEnd + "/email/create/";
    } else {
      ruta = config.servBackEnd + "/email/modify/";
    }

    fetch(ruta, datasend)
      .then((response) => response.json())
      .then((data) => {
        if (data.ok) {
          this.setState({
            copiaPedido1,
            copiaPedido2,
            mostrarMensaje: true,
            mensaje: "Tarea Finalizada correctamente",
          });
        } else {
          this.setState({
            mostrarMensaje: true,
            mensaje:
              "Configuracion con errores:" +
              errores[data.code] +
              " " +
              data.message,
          });
        }
        //this.s
        //this.setState({ data })
      });
    //});
    event.preventDefault();
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  render() {
    const validacionUser = this.state.tipo === "0" || this.state.tipo === "1";
    const mensajeConfirm = " ¿Está seguro que desea modificar el correo?";
    //console.log(this.state);
    return (
      <div className="FormularioMail">

        <div>
          <ModalConfirm
            show={this.state.show}
            enviarInfo={this.enviarInfo}
            handleClose={this.handleClose}
            mensaje={mensajeConfirm}
          ></ModalConfirm>
        </div>
        <TitleModule text={'Configuracion del correo'} />
        {!validacionUser && <p>Usuario no valido para este modulo</p>}
        {validacionUser && (
          <div>
            <BackButton />
            <Card className="card">
              <Card.Body>
                <Form className="form" onSubmit={this.handleSubmit}>
                  <Form.Row>
                    <Form.Group as={Col} controlId="formGridEmpresa">
                      <Form.Label>Empresa</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Empresa"
                        onChange={(e) =>
                          this.setState({ empresa: e.target.value })
                        }
                        value={this.state.empresa}
                        required
                        disabled
                      />
                    </Form.Group>

                    {/* <Form.Group as={Col} controlId="formGridMail">
                                            <Form.Label>E-Mail</Form.Label>
                                            <Form.Control type="email" placeholder="nombre@dominio.com" onChange={e => this.setState({ mail: e.target.value })} value={this.state.mail} required />
                                        </Form.Group>
                                    </Form.Row>

                                    <Form.Row>
                                        <Form.Group as={Col} controlId="formGridHost">
                                            <Form.Label>Host</Form.Label>
                                            <Form.Control type="text" placeholder="servidor.com.co" onChange={e => this.setState({ host: e.target.value })} value={this.state.host} required />
                                        </Form.Group> */}
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="formGridUser">
                      <Form.Label>Enviar Copia a:</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="usuario"
                        onChange={(e) =>
                          this.setState({ usuario: e.target.value })
                        }
                        value={this.state.usuario}
                        required
                      />
                    </Form.Group>

                    {/* <Form.Group as={Col} controlId="formGridPass">
                                            <Form.Label>Clave</Form.Label>
                                            <Form.Control type="password" placeholder="password" onChange={e => this.setState({ pass: e.target.value })} value={this.state.pass} required />
                                        </Form.Group> */}
                  </Form.Row>

                  <Form.Row>
                    {/* <Form.Group as={Col} controlId="formGridPuerto">
                                            <Form.Label>Puerto</Form.Label>
                                            <Form.Control type="number" placeholder="526" onChange={e => this.setState({ puerto: e.target.value })} value={this.state.puerto} required />
                                        </Form.Group>

                                        <Form.Group as={Col} controlId="formGridprotocolo">
                                            <Form.Label>Protocolo</Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ protocolo: e.target.value })} value={this.state.protocolo} required>
                                                <option value="1">SSL</option>
                                                <option value="2">TLS</option>
                                                <option value="3">STARTTLS</option>
                                            </Form.Control>
                                        </Form.Group> 

                                        <Form.Group as={Col} controlId="formGridcopia">
                                            <Form.Label>Envio Copia a </Form.Label>
                                            <Form.Control as="select" custom="true" onChange={e => this.setState({ copia: e.target.value })} value={this.state.copia} required>
                                                <option value="0">Sin Copia</option>
                                                <option value="1">{this.state.mail}</option>
                                            </Form.Control>
                                        </Form.Group>*/}
                    <Form.Group as={Col} controlId="formGridUser">
                      <Form.Label>Envio Adicional a</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="correo"
                        onChange={(e) =>
                          this.setState({ copiaadicional: e.target.value })
                        }
                        value={this.state.copiaadicional}
                      />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} controlId="formGridUser">
                      <Form.Check
                        type='checkbox'
                        label="Enviar Copia de los pedidos"
                        checked={this.state.ShowOrderEmail}
                        onChange={(e) => { this.setState({ ShowOrderEmail: e.target.checked }) }}
                      />

                    </Form.Group>
                  </Form.Row>
                  {this.state.ShowOrderEmail && <Form.Row>
                    <Form.Group as={Col} controlId="formGridUser">
                      <Form.Label>Enviar pedido a:</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="correo"
                        onChange={(e) =>
                          this.setState({ copiaPedido1: e.target.value })
                        }
                        value={this.state.copiaPedido1}
                      />
                    </Form.Group>
                    <Form.Group as={Col} controlId="formGridUser">
                      <Form.Label>Enviar pedido a:</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="correo"
                        onChange={(e) =>
                          this.setState({ copiaPedido2: e.target.value })
                        }
                        value={this.state.copiaPedido2}
                      />
                    </Form.Group>
                  </Form.Row>}
                  <Button className="m-4" variant="primary" type="submit">
                    {this.state.proceso}
                  </Button>
                  <Button
                    className="m-4"
                    variant="primary"
                    onClick={this.sendTest}
                  >
                    Enviar Correo Prueba
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </div>
        )}
        <Mensajes
          estado={this.state.mostrarMensaje}
          mensaje={this.state.mensaje}
          ocultar={() => this.setState({ mostrarMensaje: false })}
        ></Mensajes>
      </div>
    );
  }
}
export default FormularioMail;



// WEBPACK FOOTER //
// ./src/components/configuracion/configMail.jsx